import React from 'react'
import PropTypes from 'prop-types'

import { AppIcons } from '../app-icons'
import { NavbarTopNoToggle } from '../navbar-top'
import { Footer } from '../footer'
import { HeadWithPolyfills } from '../head-layout'
import { Toastr } from '../toastr/toastr'
import { Pendo } from '../pendo'

import '../../sass/businesstaxportal.scss'

export function PageLayoutNoNav (props) {
  return (
    <React.Fragment>
      <HeadWithPolyfills title={props.title} />
      <AppIcons />
      <div className='page no-sidebar'>
        <header>
          <NavbarTopNoToggle url={props.url} />
        </header>
        <div className='content-container'>
          <div className='main-container'>
            <Toastr />
            <section>
              { props.children }
            </section>
            <Footer version={props.env.VERSION} />
          </div>
        </div>
      </div>
      <Pendo env={props.env} />
    </React.Fragment>
  )
}

PageLayoutNoNav.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  url: PropTypes.object,
  env: PropTypes.object
}
